import { FIELD } from "./fieldKinds.js";
import { formatDateRange, formatLocation } from "../lib/format.js";

// STUB event type — placeholder for future categories (weddings, galas, etc.).
// Marked enabled:false so it shows as "coming soon" in the chooser. Flip to true
// and flesh out wizardSteps when ready. TODO: expand fields per future spec.
export default {
  id: "other",
  category: "professional",
  label: "Something else",
  blurb: "More event types coming soon.",
  icon: "✨",
  enabled: false,
  wizardSteps: [
    {
      id: "basics",
      title: "The essentials",
      fields: [
        { key: "title", label: "Event title", kind: FIELD.TEXT, required: true },
        { key: "subtitle", label: "Subtitle", kind: FIELD.TEXT },
        { key: "startDate", label: "Date", kind: FIELD.DATE },
        { key: "venue", label: "Venue", kind: FIELD.TEXT },
        { key: "description", label: "Details", kind: FIELD.TEXTAREA },
      ],
    },
  ],
  deriveOg(details = {}) {
    return {
      title: details.title || "An event",
      description: [formatDateRange(details.startDate, details.endDate), formatLocation(details)]
        .filter(Boolean)
        .join(" · "),
    };
  },
};
